import * as Yup from 'yup';

export const requestCarSchema = Yup.object().shape({
  brand: Yup.string()
    .nullable()
    .optional(),
  model: Yup.string()
    .nullable()
    .optional(),
  fuel: Yup.string()
    .nullable()
    .optional(),
  gearbox: Yup.string()
    .nullable()
    .optional(),
  year: Yup.number()
    .optional()
    .nullable()
    .max(3000, 'Please enter a valid year')
    .min(1900, 'Please enter a valid year'),
  numberAsked: Yup.number()
    .nullable()
    .positive()
    .optional(),
  powerfrom: Yup.number()
    .nullable()
    .positive()
    .optional(),
  powerto: Yup.number()
    .nullable()
    .positive()
    .optional(),
  powertype: Yup.number()
    .nullable()
    .positive()
    .optional(),
  kmfrom: Yup.number()
    .nullable()
    .positive()
    .optional(),
  kmto: Yup.number()
    .nullable()
    .positive()
    .optional(),
  all_validation: Yup.mixed()
    .nullable()
    .test('at-least-one', 'Please enter at least one field', function(_, context) {
      const {
        brand,
        model,
        fuel,
        gearbox,
        year,
        numberAsked,
        powerfrom,
        powerto,
        powertype,
        kmfrom,
        kmto,
      } = context.parent;
      return [brand, model, fuel, gearbox, year, numberAsked, powerfrom, powerto, powertype, kmfrom, kmto].some(v => v);
    }),
});
